  import { Users, Mail, Rocket } from "lucide-react";
  
  export const metrics = [
    {
      title: "Profiles",
      value: "0",
      change: "+0% this week",
      icon: <Users size={20} />,
      type: 'profiles' as const,
      clickable: true,
    },
    {
      title: "Events Ingested",
      value: "0",
      change: "+0%",
      icon: <Mail size={20} />,
      type: 'events' as const,
      clickable: true,
    },
    {
      title: "Active Audiences",
      value: "0",
      change: "+0",
      icon: <Users size={20} />,
      type: 'audiences' as const,
      clickable: false,
    },
    {
      title: "Journeys",
      value: "0",
      change: "+0",
      icon: <Rocket size={20} />,
      type: 'journeys' as const,
      clickable: false,
    },
  ];

  export const profileSegments = [
    {
      title: "FSI",
      description:
        "Financial services insights and segments to drive CLV and risk reduction.",
      chartData: [20, 15, 25, 30, 35, 40, 45, 50],
    },
    {
      title: "Ecommerce",
      description:
        "Commerce-ready segments: high intent, abandoners, repeat buyers.",
      chartData: [10, 20, 15, 25, 30, 40, 35, 45],
    },
    {
      title: "FMCG",
      description:
        "Segments for fast moving goods: replenishment, regional demand.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },

    {
      title: "Retail",
      description: "Daypart, location, offer affinity segments for QSR.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
    {
      title: "Quick Service Restaurant",
      description:
        "Segments for fast moving goods: replenishment, regional demand.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
    {
      title: "Telecommunication",
      description: "Prepaid/postpaid, churn risk, upsell and cross-sell.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
  ];

  export const eventsSegments = [
    {
      title: "Viewed Product",
      description: "Users who viewed product pages ≥2 times in 7d.",
      chartData: [20, 15, 25, 30, 35, 40, 45, 50],
    },
    {
      title: "Added to cart",
      description: "High intent shoppers with items in cart but no checkout..",
      chartData: [10, 20, 15, 25, 30, 40, 35, 45],
    },
    {
      title: "Checkout Started",
      description: "Initiated checkout but did not purchase in 24h.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },

    {
      title: "Purchased",
      description: "Completed order in last 30d; build post‑purchase journeys.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
    {
      title: "Email checked",
      description:
        "Clicked any campaign email within 7d.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
    {
      title: "Whatsapp Replied",
      description: "Responded to a WA message within 48h session.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
     {
      title: "SMS Opt‑in",
      description: "Consent given; eligible for promotional SMS.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
     {
      title: "Voice call missed",
      description: "Missed IVR/agent calls; trigger follow‑up message.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
     {
      title: "RCS Interacted",
      description: "Tapped RCS rich card actions in last 14d.",
      chartData: [25, 30, 35, 40, 38, 45, 42, 48],
    },
  ];

  export const connectedSources = [
    { name: "Web SDK", type: "Source" as const, status: "Active" as const },
    { name: "Mobile SDK", type: "Source" as const, status: "Active" as const },
    { name: "Shopify", type: "Source" as const, status: "Active" as const },
    { name: "Segment", type: "Source" as const, status: "Setup" as const },
  ];